import * as actionTypes from 'modules/audits/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const setUrl = (_, { payload: url }) => url;

const reset = () => initialState;

export default createReducer(initialState, {
  [actionTypes.OPEN_SHARE_MODAL]: reset,
  [actionTypes.CLOSE_SHARE_MODAL]: reset,
  [actionTypes.FETCH_FO_URL_SUCCESS]: setUrl,
});
